/*
 * Free-gift automation.
 * Keeps exactly QTY of the $0 gift product in the cart whenever there is >= 1 paid item.
 * Removes it when the cart has no paid items or the feature is disabled.
 * Reacts to every cart:update (and on load), dispatches a source-tagged cart:update so the
 * header/cart UI refresh without re-triggering this reconcile.
 */
(function () {
  var G = window.PEP_GIFT || {};
  if (!G.handle || !G.variantId) return;

  var QTY = 1; // 1 free gift per ORDER. For 1 per paid item, set QTY = paidCount inside reconcile().
  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function cartJs() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(u, b) {
    return fetch(root() + u, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(b)
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    var added = false;
    return cartJs().then(function (cart) {
      var gift = null, paid = 0;
      (cart.items || []).forEach(function (i) {
        if (i.handle === G.handle) gift = i; else paid += i.quantity;
      });
      var enabled = G.enabled !== false;
      var want = (enabled && paid > 0) ? QTY : 0;
      var have = gift ? gift.quantity : 0;
      if (have === want) return null;
      if (want === 0) return post('cart/change.js', { id: gift.key, quantity: 0 });
      if (!gift && G.available === false) return null; // can't add out-of-stock; don't spam
      if (!gift) { added = true; return post('cart/add.js', { id: G.variantId, quantity: want }); }
      return post('cart/change.js', { id: gift.key, quantity: want });
    }).then(function (changed) {
      if (!changed) return;
      if (added && G.showPopup !== false) showToast(G.message);
      return cartJs().then(function (c) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { itemCount: c.item_count, source: 'pep-free-gift' } }
        }));
      });
    }).catch(function () {}).finally(function () { busy = false; });
  }

  // ----- Toast -----
  var toastEl, toastTimer;
  function buildToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'pep-gift-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.innerHTML =
      '<span class="pep-gift-toast__icon" aria-hidden="true">🎁</span>' +
      '<span class="pep-gift-toast__msg"></span>' +
      '<button class="pep-gift-toast__close" type="button" aria-label="Dismiss">✕</button>';
    document.body.appendChild(toastEl);
    toastEl.querySelector('.pep-gift-toast__close').addEventListener('click', hideToast);
    return toastEl;
  }
  function showToast(msg) {
    var el = buildToast();
    el.querySelector('.pep-gift-toast__msg').textContent = msg || 'Free gift added to your order!';
    // restart the pop animation
    el.classList.remove('is-visible');
    void el.offsetWidth;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4500);
  }
  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-visible');
    clearTimeout(toastTimer);
  }

  // ----- Wire up -----
  document.addEventListener('cart:update', function (e) {
    if (e && e.detail && e.detail.data && e.detail.data.source === 'pep-free-gift') return; // ignore our own
    reconcile();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
